"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const DragMoveIcon = React.forwardRef(function DragMoveIcon(props, ref) {
    return (_jsxs(Icon, Object.assign({ ref: ref }, props, { children: [_jsx("rect", { height: "14", rx: "2", width: "14", x: "2", y: "2" }), _jsx("path", { d: "M18.77 8h1.076C21.036 8 22 8.964 22 10.154v9.692c0 1.19-.964 2.154-2.154 2.154h-9.692C8.964 22 8 21.036 8 19.846V18.77", strokeDasharray: "2 3" }), _jsx("path", { d: "M9.124 13.369l4.007-.236.235-4.007M8.888 8.89l4.242 4.243" })] })));
});
export default DragMoveIcon;
//# sourceMappingURL=drag-move.js.map